<template>
  <div>
    <Lottie :options="animationOptions" v-on:animCreated="handleAnimation" />
  </div>
</template>

<script>
import Lottie from 'vue-lottie';

export default {
  name: 'SingInAnimation',
  components: {
    Lottie
  },
  props: {
    animationOptions: {
      default: {}
    }
  },
  methods: {
    handleAnimation(anim) {
      this.anim = anim;
    },

    stop() {
      this.anim.stop();
    },

    play() {
      this.anim.play();
    },

    pause() {
      this.anim.pause();
    },

    onSpeedChange() {
      this.anim.setSpeed(this.animationSpeed);
    }
  }
};
</script>

<style scoped></style>
